import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

const TextFieldStyled = withStyles((theme) => ({
  root: {
    '& label': {
      '&.MuiFormLabel-root': {
        color: theme?.palette?.form?.labelColor || '#707070',
        fontSize: theme?.typography?.pxToRem?.(14) || '0.875rem',
        paddingLeft: 16,
      },
      '&.MuiFormLabel-filled': {
        color: theme?.palette?.form?.labelFilledColor || '#777777',
        fontSize: theme?.typography?.pxToRem?.(13) || '0.8125rem',
        paddingLeft: 0,
      },
      '&.Mui-focused': {
        color: theme?.palette?.primary?.main || '#387FF7',
        fontSize: theme?.typography?.pxToRem?.(13) || '0.8125rem',
        paddingLeft: 0,
      },
      '&.Mui-error': {
        color: theme?.palette?.error?.main || '#FA5252',
      },
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottomColor: theme?.palette?.form?.border || '#777777',
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: theme?.palette?.form?.border || '#777777',
    },
    '& .MuiInput-root': {
      '& .MuiInputBase-input': {
        fontSize: theme?.typography?.pxToRem?.(14) || '0.875rem',
        padding: '6px 12px 6px 16px',
      },
    },
    '& .MuiFormHelperText-root': {
      fontSize: theme?.typography?.pxToRem?.(12) || '0.75rem',
      marginLeft: 16,
    },
    '& .MuiInputAdornment-positionEnd .MuiSvgIcon-root': {
      color: '#999999',
      cursor: 'pointer',
    },
  },
}))(TextField);

export default TextFieldStyled;
